var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.game.game_status_id == 1)?_c('span',{style:(_vm.$vuetify.breakpoint.smAndUp ? 'font-size:1.2em;' : '')},[_vm._v("\n        "+_vm._s(_vm.gameTime)+"\n    ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile || _vm.layout == 1)?[(_vm.game.game_status_id !== 1)?_c('div',{class:[
                _vm.layout == 1 ? 'details-compact' : 'details',
                `${_vm.game.game_status.color}--text`,
            ],style:(_vm.$vuetify.breakpoint.smAndUp ? 'font-size:1.2em;' : '')},[_vm._v("\n            "+_vm._s(_vm.game.game_status_id == 2 && _vm.game.game_status_reason
                    ? _vm.game.game_status_reason
                    : _vm.game.game_status.name)+"\n        ")]):_vm._e(),_vm._v(" "),(
                _vm.game.showings.length > 0 &&
                _vm.game.showings[0].showing_type_id != 1
            )?_c('div',{staticClass:"details"},[_vm._v("\n            "+_vm._s(_vm.game.showings[0].highlight
                    ? " highlights from "
                    : " replay from ")+"\n            "+_vm._s(_vm.gameDate)+"\n        ")]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }